import React, { Component } from 'react';
import './Dashboard.css';
import { BrowserRouter as Router, Route, HashRouter } from 'react-router-dom';

import Header from '../../components/Header/Header';
import Sidebar from '../../components/Sidebar/Sidebar';
import Calendar from '../Calendar/Calendar';
import Clientes from '../Clientes/Clientes';
import Emails from '../Emails/Emails';
import Noticias from '../Noticias/Noticias';
import AddNoticia from '../AddNoticia/AddNoticia';
import EditNoticia from '../EditNoticia/EditNoticia';
import Bookings from '../Bookings/Bookings';
import GuestData from '../GuestData/GuestData';
import Prices from '../Prices/Prices';
import Servers from '../Servers/Servers';
import ManualBooking from '../ManualBooking/ManualBooking';
import Presents from '../Presents/Presents';
import Settings from '../Settings/Settings';
import AddExtras from '../AddExtras/AddExtras';
import Invoices from '../Invoices/Invoices';

class Dashboard extends Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    return (
      <div className="dashboardStyle">
        <div className="headerStyle">
          <Header />
        </div>
        <Router basename="/dashboard">
          <div className="bottomDashboard">
            <div className="sideBarStyle">
              <Sidebar onSelect={this.onSelect} />
            </div>
            <div className="contentStyle">
              {/* <Route exact path="/dashboard" component={Calendar} /> */}
              <Route path="/" exact component={Calendar} />
              <Route path="/calendar" component={Calendar} />
              <Route path="/prices" component={Prices} />
              <Route path="/reserves" component={Bookings} />
              <Route path="/clientes" component={Clientes} />
              <Route path="/emails" component={Emails} />
              <Route path="/noticias" component={Noticias} />
              <Route path="/addNew" component={AddNoticia} />
              <Route path="/editNew" component={EditNoticia} />
              <Route path="/guestdata" component={GuestData} />
              <Route path="/extras" component={AddExtras} />
              <Route path="/servers" component={Servers} />
              <Route path="/booking" component={ManualBooking} />
              <Route path="/regals" component={Presents} />
              <Route path="/settings" component={Settings} />
              <Route path="/invoices" component={Invoices} />
            </div>
          </div>
        </Router>
      </div>
    );
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Dashboard.js